import type { IScreensLogging } from '../../../../../api/types';
import { bridge } from '../../../../../utils';

type LogOnGoodsPressItemProps = {
  logging: IScreensLogging;
};

export const logOnGoodsPressItem = ({ logging }: LogOnGoodsPressItemProps) => {
  bridge.logAnalyticsEvent({
    channel: ['firebase', 'amplitude', 'ablylog', 'facebook'],
    name: 'CLICK_GOODS',
    analytics: logging.analytics,
    ably_only_log: logging.ably_only_log,
  });
};
